import { useCallback, useContext, useEffect, useMemo } from 'react';

import { GenericDataFormContext } from '../../shared/contexts/GenericDataForm';

import { LOADING_SAVED_PRELIQUIDATIONS_STATES, PreLiquidationStep } from '../../shared/interfaces';
import { PreliquidationLoadingCard } from '../../shared/components';

export const LoadSavedPreliquidation = () => {
  const { 
    setLoadingSavedPreliquidation, 
    setCurrentStep, 
    loadPreliquidationState,
    setLoadPreliquidationState,
    setCanShowSpinner,
  } = useContext(GenericDataFormContext);

  const allStepsAreFilled: boolean = useMemo(() => 
    loadPreliquidationState === LOADING_SAVED_PRELIQUIDATIONS_STATES.STEP_THREE_SERVICES_LOADED,
    [loadPreliquidationState]
  );

  const finishLoadingSavePreliquidation = useCallback(() => {
    setLoadingSavedPreliquidation(false);
    setCanShowSpinner(false);
    setCurrentStep(PreLiquidationStep.THREE);
  }, [
    setLoadingSavedPreliquidation,
    setCurrentStep,
    setCanShowSpinner
  ]);

  useEffect(() => {
    if(allStepsAreFilled) {
      finishLoadingSavePreliquidation();
    };
  }, [allStepsAreFilled]);

  useEffect(() => {
    setLoadPreliquidationState(LOADING_SAVED_PRELIQUIDATIONS_STATES.INIT_LOADING);
  }, []);

  return (
    <PreliquidationLoadingCard isResume />
  );
};